import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { PDFDownloadLink } from "@react-pdf/renderer";
import * as XLSX from "xlsx-js-style";
import Paginate from "../../../components/Paginate/Paginate";
import CustomLoader from "../../../components/Loading/TopBarLoader";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../../components/MDButton";
import { ShimmerPostList } from "react-shimmer-effects";
import { Modal } from "@mui/material";
import PdfLicensePage from "../../../actions/pdf_part/PdfReportLicense/PdfLicensePage";
import { deleteLicenseCargo, downloadAllReport } from "../../../actions/cargo/cargo";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Checkbox } from "@heroui/react";
import { Button } from "@heroui/button";

export default function ReportLicenseListPage() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedJens, setSelectedJens] = useState([]);

    const handleOpenModal = (jensList) => {
        setSelectedJens(jensList);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedJens([]);
    };
    const [reportData, setReportData] = useState([]);
    const [paging, setPaginate] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingExport, setLoadingExport] = useState(false);
    const [loadingExportPdf, setLoadingExportPdf] = useState(false);
    const [searchParams] = useSearchParams();
    const [selectedItems, setSelectedItems] = useState([]);
    const navigate = useNavigate();
    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            setSelectedItems(selectedItems.filter(i => i.id !== item.id));
        } else {
            setSelectedItems([...selectedItems, item]);
        }
    };
    const payload = localStorage.getItem('reportPayloadLicense');

    useEffect(() => {

        if (payload) {
            const params = new URLSearchParams(searchParams);
            const fetchData = async () => {
                try {
                    const token = Cookies.get('login_token');

                    setLoading(true);
                    const parsedPayload = JSON.parse(payload);

                    params.forEach((value, key) => {
                        parsedPayload[key] = value;
                    });

                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/ReportWeb/Reports/report-license`, parsedPayload,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Content-Type': 'application/json'
                            }
                        });
                    setReportData(response.data.data);
                    setPaginate(response.data.meta.links);
                    setLoading(false);
                } catch (error) {
                    if (axios.isAxiosError(error)) {
                        const axiosError = error;
                        if (axiosError.response && axiosError.response.status === 401) {
                            toast.error('نشست منقضی شده !');

                            navigate('/authentication/sign-in')
                        }
                        return {
                            status: 'error',
                            message: axiosError.message || 'خطا در اتصال به سرور'
                        };
                    }
                    toast.error('خطا در دریافت اطلاعات!');
                }
            };
            fetchData();
        }
    }, [searchParams]);
    const toggleSelectAll = () => {
        if (selectedItems.length === reportData.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems([...reportData]);
        }
    };

    const exportToExcel = async () => {
        let grandTotalQuantity = 0;
        let grandTotalWeight = 0;

        const data = selectedItems.map((item) => {
            let rowQuantity = 0;
            let rowWeight = 0;

            (item.jens || []).forEach((subItem) => {
                const qty = Number(subItem["jens_unit"]);
                if (!isNaN(qty)) {
                    rowQuantity += qty;
                }
                const weight = Number(subItem["weight_unit"]);
                if (!isNaN(weight)) {
                    rowWeight += weight;
                }
            });

            grandTotalQuantity += rowQuantity;
            grandTotalWeight += rowWeight;

            return {
                "تاریخ و ساعت": item.date || "",
                "شماره حواله": item.cargo_code || "",
                "پیمانکار": item.peymankar?.name || "",
                "پروژه": item.project?.title || "",
                "محل استقرار": item.location?.name || "",
                "دستگاه": item.machine?.name || "",
                "نوع دستگاه": item.machine?.type || "",
                "شیفت": item.shift?.name || "",
                "راننده": item.driver?.name || "",
                "مدت زمان عملیات": item.duration || "",
                "کرایه": item.amount_with || "",
                "هزینه کل عملیات": item.sum_amount_with || "",
                "کالا": (item.jens || [])
                  .map((subItem) => subItem["jens"]?.["title"] || "نامشخص")
                  .join("\n"),
                "کد کالا": (item.jens || [])
                  .map((subItem) => subItem["jens_code"]?.["title"] || "نامشخص")
                  .join("\n"),
                "تعداد": (item.jens || [])
                  .map((subItem) => subItem["jens_unit"] || "نامشخص")
                  .join("\n"),
                "واحد": (item.jens || [])
                  .map((subItem) => subItem["weight"]?.["title"] || "نامشخص")
                  .join("\n"),
                "وزن": (item.jens || [])
                  .map((subItem) => subItem["weight_unit"] || "نامشخص")
                  .join("\n"),
                "مبدا": item.origin?.title || "",
                "مقصد": item.destination?.title || "",
                "تجهیز بارگیری": item.equipment?.name || "",
                "اپراتور": item.operator?.name || "",
                "نام مسئول عملیات": item.user?.name || ""
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(data, { header: [
                "تاریخ و ساعت", "شماره حواله", "پیمانکار", "پروژه",
                "محل استقرار", "دستگاه", "نوع دستگاه", "شیفت", "راننده",
                "مدت زمان عملیات", "کرایه", "هزینه کل عملیات",
                "کالا", "کد کالا", "تعداد", "واحد", "وزن",
                "مبدا", "مقصد", "تجهیز بارگیری", "اپراتور", "نام مسئول عملیات"
            ]});

        const summaryRow = new Array(22).fill("");
        summaryRow[14] = `جمع تعداد: ${grandTotalQuantity}`;
        summaryRow[16] = `جمع تناژ: ${grandTotalWeight}`;
        XLSX.utils.sheet_add_aoa(worksheet, [summaryRow], { origin: -1 });

        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        const lastRow = range.e.r;

        const encodeCell = (c, r) => XLSX.utils.encode_cell({ c, r });

        const summaryStyle = {
            fill: {
                patternType: "solid",
                fgColor: { rgb: "C6EFCE" }
            },
            font: { sz: 12 },
            alignment: {
                horizontal: "center",
                vertical: "center"
            }
        };

        const quantityCellRef = encodeCell(14, lastRow);
        const weightCellRef = encodeCell(16, lastRow);
        if (worksheet[quantityCellRef]) {
            worksheet[quantityCellRef].s = summaryStyle;
        }
        if (worksheet[weightCellRef]) {
            worksheet[weightCellRef].s = summaryStyle;
        }
        const borderStyle = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
        };
        for (let c = 0; c < 22; c++) {
            const cellRef = encodeCell(c, 0);
            if (worksheet[cellRef]) {
                worksheet[cellRef].s = {
                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },
                    font: { bold: true },
                    border: borderStyle
                };
            }
        }
        if (!worksheet["!rows"]) {
            worksheet["!rows"] = [];
        }
        worksheet["!rows"][lastRow] = { hpt: 30 };
        for (let i = 0; i <= lastRow; i++) {
            worksheet["!rows"][i] = { hpt: 40 };
        }
        worksheet["!cols"] = [];
        for (let i = 0; i < 22; i++) {
            worksheet["!cols"].push({ wch: 20 });
        }

        for (let r = 1; r < lastRow; r++) {
            const fillColor = (r % 2 === 1) ? "fee4d5" : "FFFFFF";
            for (let c = 0; c < 22; c++) {
                const cellRef = encodeCell(c, r);
                if (worksheet[cellRef]) {
                    worksheet[cellRef].s = {
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: fillColor }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border:borderStyle
                    };
                }
            }
        }

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Bargo");
        XLSX.writeFile(workbook, "گزارشات-حواله-بارگو.xlsx");
    };

    const exportAllToExcel = async () => {
        let grandTotalQuantity = 0;
        let grandTotalWeight = 0;

        const res = await downloadAllReport();

        const data = res.message.data.map((item) => {
            let rowQuantity = 0;
            let rowWeight = 0;

            (item.jens || []).forEach((subItem) => {
                const qty = Number(subItem["jens_unit"]);
                if (!isNaN(qty)) {
                    rowQuantity += qty;
                }
                const weight = Number(subItem["weight_unit"]);
                if (!isNaN(weight)) {
                    rowWeight += weight;
                }
            });

            grandTotalQuantity += rowQuantity;
            grandTotalWeight += rowWeight;

            return {
                "تاریخ و ساعت": item.date || "",
                "شماره حواله": item.cargo_code || "",
                "پیمانکار": item.peymankar?.name || "",
                "پروژه": item.project?.title || "",
                "محل استقرار": item.location?.name || "",
                "دستگاه": item.machine?.name || "",
                "نوع دستگاه": item.machine?.type || "",
                "شیفت": item.shift?.name || "",
                "راننده": item.driver?.name || "",
                "مدت زمان عملیات": item.duration || "",
                "کرایه": item.amount_with || "",
                "هزینه کل عملیات": item.sum_amount_with || "",
                "کالا": (item.jens || [])
                  .map((subItem) => subItem["jens"]?.["title"] || "نامشخص")
                  .join("\n"),
                "کد کالا": (item.jens || [])
                  .map((subItem) => subItem["jens_code"]?.["title"] || "نامشخص")
                  .join("\n"),
                "تعداد": (item.jens || [])
                  .map((subItem) => subItem["jens_unit"] || "نامشخص")
                  .join("\n"),
                "واحد": (item.jens || [])
                  .map((subItem) => subItem["weight"]?.["title"] || "نامشخص")
                  .join("\n"),
                "وزن": (item.jens || [])
                  .map((subItem) => subItem["weight_unit"] || "نامشخص")
                  .join("\n"),
                "مبدا": item.origin?.title || "",
                "مقصد": item.destination?.title || "",
                "تجهیز بارگیری": item.equipment?.name || "",
                "اپراتور": item.operator?.name || "",
                "نام مسئول عملیات": item.user?.name || ""
            };
        });

        const worksheet = XLSX.utils.json_to_sheet(data, { header: [
                "تاریخ و ساعت", "شماره حواله", "پیمانکار", "پروژه",
                "محل استقرار", "دستگاه", "نوع دستگاه", "شیفت", "راننده",
                "مدت زمان عملیات", "کرایه", "هزینه کل عملیات",
                "کالا", "کد کالا", "تعداد", "واحد", "وزن",
                "مبدا", "مقصد", "تجهیز بارگیری", "اپراتور", "نام مسئول عملیات"
            ]});

        const summaryRow = new Array(22).fill("");
        summaryRow[14] = `جمع تعداد: ${grandTotalQuantity}`;
        summaryRow[16] = `جمع تناژ: ${grandTotalWeight}`;
        XLSX.utils.sheet_add_aoa(worksheet, [summaryRow], { origin: -1 });

        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        const lastRow = range.e.r;

        const encodeCell = (c, r) => XLSX.utils.encode_cell({ c, r });

        const summaryStyle = {
            fill: {
                patternType: "solid",
                fgColor: { rgb: "C6EFCE" }
            },
            font: { sz: 12 },
            alignment: {
                horizontal: "center",
                vertical: "center"
            }
        };

        const quantityCellRef = encodeCell(14, lastRow);
        const weightCellRef = encodeCell(16, lastRow);
        if (worksheet[quantityCellRef]) {
            worksheet[quantityCellRef].s = summaryStyle;
        }
        if (worksheet[weightCellRef]) {
            worksheet[weightCellRef].s = summaryStyle;
        }
        const borderStyle = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
        };
        for (let c = 0; c < 22; c++) {
            const cellRef = encodeCell(c, 0);
            if (worksheet[cellRef]) {
                worksheet[cellRef].s = {
                    alignment: {
                        horizontal: "center",
                        vertical: "center"
                    },
                    font: { bold: true },
                    border: borderStyle
                };
            }
        }
        if (!worksheet["!rows"]) {
            worksheet["!rows"] = [];
        }
        worksheet["!rows"][lastRow] = { hpt: 30 };
        for (let i = 0; i <= lastRow; i++) {
            worksheet["!rows"][i] = { hpt: 40 };
        }
        worksheet["!cols"] = [];
        for (let i = 0; i < 22; i++) {
            worksheet["!cols"].push({ wch: 20 });
        }

        for (let r = 1; r < lastRow; r++) {
            const fillColor = (r % 2 === 1) ? "fee4d5" : "FFFFFF";
            for (let c = 0; c < 22; c++) {
                const cellRef = encodeCell(c, r);
                if (worksheet[cellRef]) {
                    worksheet[cellRef].s = {
                        fill: {
                            patternType: "solid",
                            fgColor: { rgb: fillColor }
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border:borderStyle
                    };
                }
            }
        }

        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Bargo");
        XLSX.writeFile(workbook, "گزارشات-حواله-بارگو.xlsx");
    };

    return (
        <div>
            <CustomLoader isLoading={loading}/>
            <DashboardLayout>
                <div className={"flex w-full items-center gap-4"}>

                    {selectedItems.length > 0 &&
                        <PDFDownloadLink
                            className="flex items-center px-5 py-2.5 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            document={<PdfLicensePage data={selectedItems}/>}
                            fileName="bargo-license-report.pdf"
                        >
                            خروجی پی دی اف
                            <img src="/images/pdf.svg" alt="" className="w-5 h-5 ms-4"/>

                        </PDFDownloadLink>
                    }
                    {selectedItems.length > 0 &&
                      <MDButton
                        color={"success"}
                        onClick={() => {
                            exportToExcel()
                        }}
                        type="button"
                        disabled={loadingExport}
                        className="flex items-center px-5 py-2.5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
                      >
                          {loadingExport ? 'درحال دریافت گزارش...' : 'خروجی اکسل'}
                          <img src="/images/excel.svg" alt="" className="w-5 h-5 ms-4"/>
                      </MDButton>
                    }
                    {/*<Button*/}
                    {/*  color="success"*/}
                    {/*  onClick={() => exportAllToExcel()}*/}
                    {/*  isLoading={loadingExport}*/}
                    {/*  className="flex items-center px-5 py-2.5 text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"*/}
                    {/*>*/}
                    {/*    {loadingExport ? "درحال دریافت گزارش..." : "خروجی اکسل تمامی گزارشات"}*/}
                    {/*    <img src="/images/excel.svg" alt="" className="w-5 h-5 ms-4" />*/}
                    {/*</Button>*/}
                </div>
                {loading ?  <div className={"mt-5"}>
                      <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} />
                  </div>
                  :  <div className="mt-5 relative overflow-x-auto shadow-md sm:rounded-lg">

                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">

                        <thead
                            className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>

                            <th className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                                <Checkbox className={"text-sm font-normal"}
                                          checked={selectedItems.length === reportData.length && reportData.length > 0}

                                          onChange={toggleSelectAll}>انتخاب همه</Checkbox>
                            </th>
                            <th className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>انتخاب</th>
                            <th scope="col" className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                                تاریخ و ساعت
                            </th>
                            <th scope="col" className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                                شماره حواله
                            </th>
                            <th scope="col" className="px-10 text-center py-3" style={{ whiteSpace: "nowrap" }}>
                                پیمانکار
                            </th>
                            <th scope="col" className="px-6 py-3" style={{ whiteSpace: "nowrap" }}>
                                پروژه
                            </th>
                            <th scope="col" className="px-16 text-center justify-center w-full py-3"
                                style={{ whiteSpace: "nowrap" }}>
                                محل استقرار
                            </th>
                            <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                                دستگاه
                            </th>
                            <th scope="col" className="px-10 py-3" style={{ whiteSpace: "nowrap" }}>
                                نوع دستگاه
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                شیفت
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                راننده
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                کرایه
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                هزینه کل عملیات
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                کالا
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                مبدا
                            </th>
                            <th scope="col" className="text-center py-3" style={{ whiteSpace: "nowrap" }}>
                                مقصد
                            </th>
                            <th scope="col" className="text-center px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                تجهیز بارگیری
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                اپراتور
                            </th>
                            <th scope="col" className="text-center px-28 py-3" style={{ whiteSpace: "nowrap" }}>
                                نام مسئول عملیات
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                عملیات
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                توضیحات
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                نوع گزارش
                            </th>
                            <th scope="col" className="px-16 py-3" style={{ whiteSpace: "nowrap" }}>
                                وضیعت حواله
                            </th>
                            <th scope="col" className="px-10 py-3 text-center" style={{ whiteSpace: "nowrap" }}>
                                عملیات
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        {reportData.map((item, index) => (
                            <tr
                                className="border-b bg-white hover:bg-gray-50 dark:bg-boxdark dark:border-gray-700 dark:hover:bg-gray-600"
                                key={index}
                            >
                                <td></td>
                                <td className="px-6 py-4">
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.includes(item)}
                                        onChange={() => handleCheckboxChange(item)}
                                    />
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white" dir="ltr"
                                    style={{ whiteSpace: "nowrap" }}>
                                    {item["date"] ? item["date"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                                    {item["cargo_code"] ? item["cargo_code"] :
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="text-center w-full py-4">
                                    <div className="text-center flex justify-center items-center ">
                                        {item['peymankar'] && item['peymankar']['name'] ? (
                                            <span className={"font-bold"}>{item['peymankar']['name']}</span>
                                        ) : (
                                            <span className={"font-normal"}>ثبت نشده</span>
                                        )}
                                    </div>
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['project'] && item['project']['title'] ? (
                                        item['project']['title']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="py-4 text-center justify-center font-semibold text-gray-900 dark:text-white">
                                    {item['location'] && item['location']['name'] ? (
                                        item['location']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['machine'] && item['machine']['name'] ? (
                                        item['machine']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['machine'] && item['machine']['type'] ? (
                                        item['machine']['type']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['shift'] && item['shift']['name'] ? (
                                      item['shift']['name']
                                    ) : (
                                      <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['driver'] && item['driver']['name'] ? (
                                        item['driver']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>

                                <td className="text-center justify-center px-10 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['amount_with'] ? `${item['amount_with']} تومان` :
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['sum_amount_with'] ? `${item['sum_amount_with']} تومان` :
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="px-5 py-4 font-semibold flex-col text-gray-900 dark:text-white">
                                    <MDButton color={"info"}
                                        onClick={() => handleOpenModal(item['jens'])}
                                        className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                    >
                                        نمایش کالا
                                    </MDButton>
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['origin'] && item['origin']['title'] ? (
                                        item['origin']['title']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['destination'] && item['destination']['title'] ? (
                                        item['destination']['title']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['equipment'] && item['equipment']['name'] ? (
                                        item['equipment']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['operator'] && item['operator']['name'] ? (
                                        item['operator']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['user'] && item['user']['name'] ? (
                                        item['user']['name']
                                    ) : (
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    )}
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['type'] ? item['type'] :
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                    {item['desc'] ? item['desc'] :
                                        <span className={"font-normal"}>ثبت نشده</span>
                                    }
                                </td>

                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{whiteSpace:'nowrap'}}>
                                      <span className={"text-blue-600"}>مجوز</span>
                                </td>
                                <td className="text-center justify-center px-16 py-4 font-semibold text-gray-900 dark:text-white" style={{ whiteSpace: 'nowrap' }}>
                                    {item['status'] === 'expired' ? (
                                      <span className="text-red-600">ابطال شده</span>
                                    ) : item['status'] === 'waiting' ? (
                                      <span className="text-yellow-500">در انتظار</span>
                                    ) : (
                                      <span className="text-green-600">مجاز</span>
                                    )}
                                </td>

                                <td className="flex p-4 gap-4">
                                    <MDButton
                                      color={"info"}
                                      style={{whiteSpace:'nowrap'}}
                                      onClick={() => {
                                          navigate(`/license-cargos/edit/${item.id}`)
                                      }}
                                      className="custom-link text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center gap-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                                    >
                                        <FaEdit className="text-base" />
                                        ویرایش
                                    </MDButton>
                                    <MDButton
                                      color={"error"}
                                      style={{whiteSpace:'nowrap'}}
                                      onClick={async() => {
                                          if(!window.confirm('آیا میخواهید این گزارش حذف شود؟')) {
                                              return;
                                          }
                                          await deleteLicenseCargo({id: item['id']}).then((res)=>{
                                              toast.success('با موفقیت حذف شد!');
                                              window.location.reload();
                                          }).catch((e)=>{
                                              toast.error('خطا در حذف گزارش!');
                                          });
                                      }}
                                      className="custom-link text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center gap-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                                    >
                                        <FaTrash className="text-base" />
                                        حذف
                                    </MDButton>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>

                </div>}
                {paging.length > 1 ? <Paginate links={paging}/> : null}

            </DashboardLayout>
            {isModalOpen && (
              <Modal
                open={isModalOpen}
                className="mt-10 absolute inset-0 flex justify-center items-center z-10"
                onClick={handleCloseModal}
              >
                    <div
                        className="bg-white no-scrollbar overflow-y-auto h-1/2 dark:bg-boxdark p-6 rounded-lg max-w-3xl w-full shadow-lg"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex justify-between items-center mb-6 border-b border-gray pb-4">
                            <h2 className="text-xl font-bold text-gray-700 dark:text-white">لیست کالا</h2>
                            <button
                                onClick={handleCloseModal}
                                type="button"
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            >
                                <svg
                                    className="w-3 h-3"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 14 14"
                                >
                                    <path
                                        stroke="currentColor"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                    />
                                </svg>
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="mb-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {selectedJens.map((subItem, index) => (
                                <div
                                    key={index}
                                    className="bg-gray-50 dark:bg-gray-800 rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow duration-300"
                                >
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        کالا: {subItem["jens"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        کد کالا: {subItem["jens_code"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        تعداد: {subItem["jens_unit"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        شماره کالا: {subItem["jens_number"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200 mb-2">
                                        واحد: {subItem["weight"]["title"]}
                                    </div>
                                    <div className="text-gray-700 text-lg dark:text-gray-200">
                                        وزن: {subItem["weight_unit"]}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <MDButton
                          color={"error"}
                            onClick={handleCloseModal}
                            className="mt-6 text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                        >
                            بستن
                        </MDButton>
                    </div>
                </Modal>
            )}
        </div>
    );
}
